import { Action, Type } from "../actions/FlightPairingStatus/FlightPairingStatus.Actions";
import { IFlightPairingStatus, IFlightPairingStatusMap } from "@vmosolutions/oc-interfaces";

export interface IFlightPairingStatusState {
  selectedFlightStatus: IFlightPairingStatus | null;
  flightStatusMap: IFlightPairingStatusMap | null;
}

const initialState: IFlightPairingStatusState = {
  selectedFlightStatus: null,
  flightStatusMap: null,
};

export const FlightPairingStatusReducer = (
  state: IFlightPairingStatusState = initialState,
  action: Action
): IFlightPairingStatusState => {
  switch (action.type) {
    case Type.SET_FLIGHT_PAIRING_STATUS:
      return {
        ...state,
        selectedFlightStatus: action.selectedFlightStatus,
      };
    case Type.SET_FLIGHT_PAIRING_STATUS_MAP:
      return {
        ...state,
        flightStatusMap: action.flightStatusMap,
      };
    default:
      return state;
  }
};
